import { useMemo } from 'react'
import { Button } from 'react-bootstrap'
import { useText } from '../context/TextContext'
import { Offer } from '../models/shared/Offer'
import DealModalSection from './DealModalSection'
import { getLatestOffer } from '../utils/logic'
import { calculateLineItemsTotal, formatCurrency } from '../utils/shared/priceCalculator'
import { useEnsureOffer } from '../hooks/useEnsureOffer'
import { Deal } from '../models/shared/Deal'
import OfferState from './OfferState'
import { useOrganization } from '../context/OrganizationContext'

interface Props {
    offers: Offer[]
    deal: Deal
    className?: string
}

export default function DealOfferSection({ offers, deal, className }: Props) {
    const text = useText()
    const { organization } = useOrganization()
    const currency = organization.settings?.currency ?? 'SEK'
    const handleOfferClick = useEnsureOffer();

    const latestOffer = useMemo(() => getLatestOffer(offers), [offers])
    const sums = calculateLineItemsTotal(latestOffer?.lineItems || []);

    return (
        <DealModalSection title={text.offer} open>

            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <small className="text-muted">
                        {text.status}: <OfferState offer={latestOffer} />
                    </small>
                    <div className="fs-3 fw-bold">{formatCurrency(sums.totalWithVat, currency)}</div>
                </div>

                <Button
                    variant="outline-primary"
                    onClick={() => handleOfferClick(deal, offers)}
                >
                    {text.manageOffers}
                </Button>
            </div>
        </DealModalSection>
    )
}
